import MuiButton from "./MuiButton";
import MuiPaper from "./MuiPaper";
import MuiChip from "./MuiChip";
import MuiAvatar from "./MuiAvatar";
import MuiTooltip from "./MuiTooltip";
import MuiFormControl from "./MuiTooltip";
import MuiDivider from "./MuiDivider";
import MuiDialog from "./MuiDialog";
import MuiDialogTitle from "./MuiDialogTitle";
import MuiListItemButton from "./MuiListItemButton";
import TextField from "./MuiTextField";
import MuiAlert from "./MuiAlert";

const components = {
  MuiButton,
  MuiPaper,
  MuiChip,
  MuiAvatar,
  MuiTooltip,
  MuiFormControl,
  MuiDivider,
  MuiDialog,
  MuiDialogTitle,
  MuiListItemButton,
  TextField,
  MuiAlert,
};

export default components;
